<template>
	<div>
		<!-- 表格 -->
		<el-table class="right-block" size="small" :data="listData" border>
			<el-table-column prop="id" label="序号" align="center" width="80"> </el-table-column>
			<el-table-column prop="name" label="姓名" align="center"> </el-table-column>
			<el-table-column prop="school" label="学校" align="center"> </el-table-column>
			<el-table-column prop="position" label="职位" align="center"> </el-table-column>
			<el-table-column prop="level" label="类别" align="center"> </el-table-column>
			<el-table-column label="操作" align="center" width="100">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="handleEdit(scope.$index)">
						审核
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 审核弹窗 -->
		<el-dialog :title="dialogTitle" width="1000px" :visible.sync="editFormVisible" @click="closeDialog">
			<div class="info-block">
				<div class="info-block-l">
					<!-- 头部：头像 + 姓名 -->
					<div class="info-header">
						<div class="avatar-name">
							<el-image v-if="detailForm.avatar" :src="detailForm.avatar" fit="cover"
								class="teacher-avatar"></el-image>
							<div v-else class="teacher-avatar-placeholder">
								<i class="el-icon-user"></i>
							</div>
							<div class="teacher-name-wrapper">
								<div class="info-title">{{ detailForm.name || '未命名' }}</div>
								<el-tag size="small" type="primary" effect="dark">待审核</el-tag>
							</div>
						</div>
					</div>

					<!-- 详细信息卡片：左右两栏布局 -->
					<div class="detail-card">
						<div class="detail-left">
							<div class="app-item">
								<span class="app-label">学校：</span>
								<span class="app-value">{{ detailForm.school || '未填写' }}</span>
							</div>
							<div class="app-item">
								<span class="app-label">职位：</span>
								<span class="app-value">{{ detailForm.position || '未填写' }}</span>
							</div>
							<div class="app-item">
								<span class="app-label">类别：</span>
								<span class="app-value">{{ detailForm.level || '未填写' }}</span>
							</div>
							<div class="app-item">
								<span class="app-label">电话号码：</span>
								<span class="app-value">{{ detailForm.phone || '未填写' }}</span>
							</div>
							<div class="app-item">
								<span class="app-label">简介：</span>
								<span class="app-value"
									style="white-space: pre-line;">{{ detailForm.intro || '未填写' }}</span>
							</div>
							<div class="app-item">
								<span class="app-label">技能：</span>
								<span class="app-tags">
									<el-tag size="small" v-for="(skill, idx) in (detailForm.skills || [])" :key="idx"
										type="primary" effect="plain" style="margin-right: 4px;">
										{{ skill }}
									</el-tag>
									<span v-if="!detailForm.skills || detailForm.skills.length === 0"
										style="color: #909399;">
										未填写
									</span>
								</span>
							</div>
						</div>
						<!-- 右侧：简历图片（竖向长图） -->
						<div class="detail-right">
							<div v-if="detailForm.resumeImg" class="resume-wrapper">
								<el-image :src="detailForm.resumeImg" fit="contain" class="resume-image"></el-image>
							</div>
							<div v-else class="resume-placeholder">
								<i class="el-icon-picture-outline"></i>
								<span>暂无简历图片</span>
							</div>
						</div>
					</div>
				</div>

				<!-- 底部按钮 -->
				<div class="dialog-footer">
					<el-button class="stu-bottom-button" size="mini" type="success" @click="handleApprove(1)"
						plain>接收</el-button>
					<el-button class="stu-bottom-button" size="mini" type="warning" @click="handleApprove(0)"
						plain>驳回</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		GetTheTeacherList,
		SubmitReviewTeacher,
		formatTime,
		PictureServer,
		GetTheApTeacherInfo,
	} from '../../api/userMG';
	import {
		Poslist,
		Skill
	} from '../../utils/util';
	const id_type = ['学校教师', '机构教师', '独立教师']
	export default {
		data() {
			return {
				listData: [],
				editFormVisible: false,
				dialogTitle: '老师信息审核',
				detailForm: {
					name: '',
					school: '',
					position: '',
					level: '',
					phone: '',
					avatar: '',
					intro: '',
					resumeImg: '',
					skills: []
				},
				currentIndex: -1
			};
		},
		created() {
			GetTheTeacherList().then((res) => {
				var works = [],
					items = null
				res.w.forEach((e) => {
					items = {
						id: e[0],
						name: e[1],
						level: id_type[e[3]],
						position: Poslist[e[4]].text,
						sid: e[2],
					};
					for (var j = 0; j < res.s.length; j++) {
						if (res.s[j][0] == e[2]) {
							items.school = res.s[j][1];
							break;
						}
					}
					console.log(items)
					works.push(items);
				});
				this.listData = works;
			});
		},
		methods: {
			loadMockData() {
				// 模拟数据（实际请从接口获取）
				this.listData = [{
						id: 1,
						name: '张老师',
						school: '北京大学',
						position: '副教授',
						level: '高级',
						phone: '13800138001',
						avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
						intro: '计算机科学博士，研究方向为人工智能、自然语言处理。',
						resumeImg: 'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
						skills: ['Python', '机器学习', '深度学习']
					},
					{
						id: 2,
						name: '李老师',
						school: '清华大学',
						position: '教授',
						level: '正高级',
						phone: '13800138002',
						avatar: '',
						intro: '数学系主任，多年教学经验，发表论文数十篇。',
						resumeImg: '',
						skills: ['数学分析', '高等代数']
					}
				];
			},
			handleEdit(index) {
				this.currentIndex = index;
				const item = this.listData[index];
				GetTheApTeacherInfo(this.listData[index].id).then(
					(res) => {
						var stab = [],
							stt
						if (res[0]) {
							var stt = res[0].split(',')
							stt.forEach(e => {
								stab.push(Skill[e].text)
							})
						}
						this.detailForm = {
							name: item.name || '',
							school: item.school || '',
							position: item.position || '',
							level: item.level || '',
							phone: res[3] || '',
							avatar: (PictureServer.TheClass + 'teacheravatar_' + item.id + '.png') || '',
							intro: res[1] || '',
							resumeImg: (PictureServer.TheClass + 'teachers_info_' + item.id + '.png') || '',
							skills: stab
						};
						this.editFormVisible = true;
					})

			},
			closeDialog() {
				this.editFormVisible = false;
			},
			handleApprove(type) {
				const that = this;
				const teacherId = this.listData[this.currentIndex].id;
				if (!teacherId) return;
				const actionText = type === 1 ? '接收' : '驳回';
				const promptMsg = type === 1 ? '确认通过该老师信息？' : '确认驳回该老师信息？';
				const promptTitle = type === 1 ? '请输入备注（可选）' : '请说明驳回原因';

				this.$prompt(promptTitle, promptMsg, {
					inputErrorMessage: '输入不能为空',
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputValidator: (value) => {
						if (type === 0 && !value) {
							return '驳回原因不能为空';
						}
					}
				}).then(({
					value
				}) => {
					SubmitReviewTeacher({
						i: that.listData[that.currentIndex].id,
						c: value||'请退出后重新登录',
						k: type + '',
					}).then((res) => {
						if (res) {
							that.$message.success(`已${actionText}该老师`);
							that.listData.splice(that.currentIndex,1);
							that.editFormVisible = false;
						}
					});

				}).catch(() => {});
			}
		}
	};
</script>

<style scoped>
	/* ====== 统一定义 ====== */
	:root {
		--primary: #409eff;
		--primary-light: #ecf5ff;
		--primary-border: #b3d8ff;
		--success: #67c23a;
		--warning: #e6a23c;
		--radius: 8px;
		--shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
		--transition: 0.25s;
	}

	/* 表格 */
	.right-block {
		margin-top: 16px;
		border-radius: var(--radius);
		overflow: hidden;
		box-shadow: var(--shadow);
	}

	.right-block ::v-deep .el-table__row {
		transition: background var(--transition);
	}

	.right-block ::v-deep .el-table__row:hover {
		background-color: #f5f9ff !important;
	}

	/* 对话框 */
	.el-dialog {
		border-radius: var(--radius) !important;
		box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15) !important;
	}

	.el-dialog__header {
		border-bottom: 1px solid #e4e7ed;
		padding: 18px 24px !important;
		background: #fafafa;
		border-radius: var(--radius) var(--radius) 0 0;
	}

	.el-dialog__title {
		font-weight: 600;
		font-size: 18px;
		color: #303133;
	}

	.el-dialog__body {
		padding: 24px !important;
	}

	/* 信息主体 */
	.info-block {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.info-block-l {
		background: #fff;
		padding: 16px 20px 20px 20px;
		border-radius: var(--radius);
		border: 1px solid #ebeef5;
		box-shadow: var(--shadow);
	}

	/* 头部头像+姓名 */
	.info-header {
		margin-bottom: 16px;
	}

	.avatar-name {
		display: flex;
		align-items: center;
		gap: 18px;
	}

	.teacher-avatar {
		width: 70px;
		height: 70px;
		border-radius: 50%;
		border: 3px solid #ffffff;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
		flex-shrink: 0;
	}

	.teacher-avatar-placeholder {
		width: 70px;
		height: 70px;
		border-radius: 50%;
		background: #f0f2f5;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 32px;
		color: #bfcbd9;
		border: 3px solid #ffffff;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
		flex-shrink: 0;
	}

	.teacher-name-wrapper {
		display: flex;
		flex-direction: column;
	}

	.teacher-name-wrapper .info-title {
		font-size: 24px;
		font-weight: 700;
		color: #1f2f3d;
		letter-spacing: 1px;
		margin-bottom: 4px;
	}

	/* 详情卡片：左右两栏 */
	.detail-card {
		display: flex;
		gap: 20px;
		background: var(--primary-light);
		border: 1px solid var(--primary-border);
		border-radius: var(--radius);
		padding: 16px 18px;
		min-height: 180px;
	}

	.detail-left {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.detail-right {
		flex: 0 0 200px;
		/* 固定宽度，可根据图片调整 */
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fff;
		border-radius: 4px;
		border: 1px dashed #dcdfe6;
		padding: 6px;
	}

	/* 左侧信息项 */
	.app-item {
		display: flex;
		align-items: baseline;
		font-size: 14px;
		color: #303133;
		line-height: 1.6;
	}

	.app-label {
		font-weight: 600;
		color: #606266;
		min-width: 80px;
		flex-shrink: 0;
	}

	.app-value {
		color: #303133;
		word-break: break-word;
	}

	.app-tags {
		display: flex;
		flex-wrap: wrap;
		gap: 4px;
	}

	.app-tags .el-tag {
		margin-right: 0;
	}

	/* 右侧简历图片 */
	.resume-wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.resume-image {
		width: 100%;
		height: auto;
		max-height: 260px;
		/* 限制高度，防止过长 */
		object-fit: contain;
		border-radius: 4px;
	}

	.resume-placeholder {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #c0c4cc;
		font-size: 14px;
	}

	.resume-placeholder i {
		font-size: 40px;
		margin-bottom: 6px;
	}

	/* 底部按钮 */
	.dialog-footer {
		display: flex;
		justify-content: flex-end;
		gap: 12px;
		padding: 14px 20px;
		background: #fafafa;
		border-top: 1px solid #e4e7ed;
		border-radius: 0 0 var(--radius) var(--radius);
		margin-top: 4px;
	}

	.stu-bottom-button {
		min-width: 80px;
		border-radius: 20px !important;
		font-weight: 500;
		letter-spacing: 0.5px;
		transition: all var(--transition);
	}

	.stu-bottom-button.el-button--success {
		background-color: var(--success);
		border-color: var(--success);
		color: #fff;
	}

	.stu-bottom-button.el-button--success:hover {
		background-color: #85ce61;
		border-color: #85ce61;
		box-shadow: 0 4px 10px rgba(103, 194, 58, 0.3);
	}

	.stu-bottom-button.el-button--warning {
		background-color: var(--warning);
		border-color: var(--warning);
		color: #fff;
	}

	.stu-bottom-button.el-button--warning:hover {
		background-color: #ebb563;
		border-color: #ebb563;
		box-shadow: 0 4px 10px rgba(230, 162, 60, 0.3);
	}

	/* 响应式 */
	@media screen and (max-width: 768px) {
		.el-dialog {
			width: 92% !important;
		}

		.detail-card {
			flex-direction: column;
		}

		.detail-right {
			flex: 1;
			min-height: 120px;
			width: 100%;
		}

		.resume-image {
			max-height: 160px;
		}

		.avatar-name {
			gap: 12px;
		}

		.teacher-avatar,
		.teacher-avatar-placeholder {
			width: 56px;
			height: 56px;
		}

		.teacher-name-wrapper .info-title {
			font-size: 20px;
		}

		.app-label {
			min-width: 60px;
		}

		.dialog-footer {
			flex-direction: column;
			align-items: stretch;
		}

		.stu-bottom-button {
			width: 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/contest/teacherCerApplication.vue